import { useCallback, useState } from 'react';

const useError = () => {
  const [error, setError] = useState(null);

  const setErrorMessage = useCallback((message) => {
    setError(message);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const hasError = useCallback(() => error !== null, [error]);

  return {
    error,
    setErrorMessage,
    clearError,
    hasError
  };
};

export default useError;
